/* arvc: cart drawer behaviour (11-10-2026). Every change goes through the Ajax Cart API with
   sections=cart-drawer,cart-icon-bubble and the response is handed to Dawn's own <cart-drawer>.renderContents(), so the
   drawer and the header bubble re-render from the same Liquid as on page load.
   Quantities are set per VARIANT, not per line: Shopify splits a Buy X Get Y bundle into a paid line and a free line of the
   same variant, the drawer shows them as one row, and a change gives the first line the new total and the others 0 (the
   discount then splits them again). window.arvcAdd() is the add-to-cart used by the PDP button and the upgrade offers. */
(function () {
  if (window.__arvc) return;
  window.__arvc = 1;
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function drawer() { return document.querySelector('cart-drawer'); }
  function inner() { return document.querySelector('#CartDrawer .drawer__inner'); }
  function lines() {
    var s = document.querySelector('#CartDrawer [data-arvc-lines]');
    try { return s ? JSON.parse(s.textContent) : []; } catch (e) { return []; }
  }
  function busy(on) {
    var i = inner();
    if (!i) return;
    i.classList.toggle('is-busy', on);
    i.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function showError(err) {
    var box = document.getElementById('CartDrawer-CartErrors');
    var msg = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
    if (box) box.textContent = msg;
  }
  function post(url, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw j;
        return j;
      });
    });
  }
  // count: item count after the change when the response carries it (update.js), unknown after add.js (never empty)
  function show(state, count, focusKey) {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function' || !state.sections) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }
    d.classList.toggle('is-empty', typeof count === 'number' && count === 0);
    d.renderContents(state);
    if (focusKey) {
      setTimeout(function () {
        var el = d.querySelector('[data-arvc-focus="' + focusKey + '"]');
        if (el) el.focus();
      }, 80);
    }
    document.dispatchEvent(new CustomEvent('arvc:updated', { detail: { count: count } }));
  }

  window.arvcAdd = function (items, opener) {
    busy(true);
    return post('/cart/add.js', { items: items })
      .then(function (state) {
        var d = drawer();
        if (d && opener && typeof d.setActiveElement === 'function') d.setActiveElement(opener);
        show(state, undefined, null);
        return state;
      })
      .finally(function () { busy(false); });
  };

  function setVariant(variantId, total, focusKey) {
    var updates = {};
    var first = true;
    lines().forEach(function (l) {
      if (String(l.v) !== String(variantId)) return;
      updates[l.key] = first ? Math.max(0, total) : 0;
      first = false;
    });
    if (first) return;
    busy(true);
    post('/cart/update.js', { updates: updates })
      .then(function (cart) { show(cart, cart.item_count, total > 0 ? focusKey : null); })
      .catch(showError)
      .finally(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('#CartDrawer [data-arvc-set], #CartDrawer [data-arvc-add]') : null;
    if (!t) return;
    e.preventDefault();
    if (inner() && inner().classList.contains('is-busy')) return;
    if (t.hasAttribute('data-arvc-add')) {
      var focusKey = t.getAttribute('data-arvc-focus');
      window.arvcAdd([{ id: +t.getAttribute('data-variant'), quantity: +t.getAttribute('data-arvc-add') }], null)
        .then(function () {
          // the offer is replaced by the next one (or disappears): keep focus inside the drawer
          setTimeout(function () {
            var d = drawer();
            var el = d && (d.querySelector('[data-arvc-focus="' + focusKey + '"]') || d.querySelector('#CartDrawer-Checkout'));
            if (el) el.focus();
          }, 80);
        })
        .catch(showError);
    } else {
      setVariant(t.getAttribute('data-variant'), +t.getAttribute('data-arvc-set'), t.getAttribute('data-arvc-focus'));
    }
  });
})();
